<template>
  <v-card>
    <v-card-text>
      <h3>Electric Charge</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Abcoulomb (abC)',
          val: 1
        },
        {
          text: 'Ampere-hour (Ah)',
          val: 0.00277777777778
        },
        {
          text: 'Coulomb (C)',
          val: 10
        },
        {
          text: 'Elementary charge (e)',
          val: 62415094741540000000
        },
        {
          text: 'Faraday (F)',
          val: 0.0001036426864904
        },
        {
          text: 'Kilocoulomb (kC)',
          val: 0.01
        },
        {
          text: 'Megacoulomb (MC)',
          val: 0.00001
        },
        {
          text: 'Microcoulomb (µC)',
          val: 10000000
        },
        {
          text: 'Milliampere-hour (mAh)',
          val: 2.77777777778
        },
        {
          text: 'Millicoulomb (mC)',
          val: 10000
        },
        {
          text: 'Nanocoulomb (nC)',
          val: 10000000000
        },
        {
          text: 'Statcoulomb (statC)',
          val: 29979245800
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// electric-charge.vue?a028ea94